import React, { Component } from "react"
import PropTypes from "prop-types"

class SelectList extends Component {
  onSelectChange = (e) => {
    this.props.onSelectChange(e)
  }

  setInitialOption = () => {
    return (
      <option
        disabled={this.props.initialSelection.disabled}
        key={this.props.initialSelection.id}
        value={this.props.initialSelection.id}
      >
        {this.props.initialSelection.text}
      </option>
    )
  }

  generateOptions = () => {
    const options = this.props.data
    const { selectedValue } = this.props

    if (options && options.length > 0) {
      return options.map((q) => {
        if (q.enabled === false) {
          return (
            <option disabled key={q.id} value={q.id}>
              {q.text}
            </option>
          )
        }
        return (
          <option key={q.id} value={q.id} selected={q.id === selectedValue}>
            {q.text}
          </option>
        )
      })
    }
    return <option />
  }

  render() {
    return (
      <select
        className="form-control"
        onChange={this.onSelectChange}
        value={this.props.selectedValue ? this.props.selectedValue : undefined}
      >
        {this.props.initialSelection ? this.setInitialOption() : null}
        {this.generateOptions()}
      </select>
    )
  }
}

SelectList.propTypes = {
  initialSelection: PropTypes.shape({
    id: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
  }),
  selectedValue: PropTypes.number,
  onSelectChange: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
  })).isRequired,
}

SelectList.defaultProps = {
  initialSelection: null,
  selectedValue: null,
}

export default SelectList



// WEBPACK FOOTER //
// ./src/components/custom-report/SelectList.jsx